/* External dependencies */
import * as React from 'react';

/* Local dependencies */
import { IconProps } from './types';

export default function ArrowLanguageIcon({
  width = 12,
  height = 12,
  fill = '#222B45',
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z"
        fill={fill}
      />
    </svg>
  );
}
